<div class="loader-wrapper" *ngIf="visible">
    <div class="loader">Loading...</div>
</div>
